export default {
  step7:[
    {
      id:35,
      step: 7,
      tab:1,
      stepJp: "外側ダイヤ",
      name: "ふせこみ",
      property: "outsideDia",
      val: "fusekomiBase",
      option:null,
      summary:"",
      price:8000//10000,
    },
    {
      id:36,
      step: 7,
      stepJp: "外側ダイヤ",
      tab:1,
      name: "4点留め（平行）",
      property: "outsideDia",
      val: "yontendomeheikouBase",
      option:null,
      summary:"",
      price:8000//10000,
    },
    {
      id:37,
      step: 7,
      stepJp: "外側ダイヤ",
      tab:1,
      name: "4点留め（十字）",
      property: "outsideDia",
      val: "yontendomejujiBase",
      option:null,
      summary:"",
      price:8000//10000,
    },
    {
      id:38,
      step: 7,
      stepJp: "外側ダイヤ",
      tab:1,
      name: "星留め（横長）",
      property: "outsideDia",
      val: "hoshidomeBase",
      option:null,
      summary:"",
      price:8000//10000,
    },
    {
      id:39,
      step: 7,
      stepJp: "外側ダイヤ",
      tab:1,
      name: "太陽留め",
      property: "outsideDia",
      val: "taiyodomeBase",
      option:null,
      summary:"",
      price:8000//10000,
    },
    {
      id:40,
      step: 7,
      stepJp: "外側ダイヤ",
      tab:1,
      name: "彫りのみ（太陽彫り）",
      property: "outsideDia",
      val: "taiyoboriBase",
      //option:null,
      summary:"",
      price:5000,
    },
    {
      id:41,
      step: 7,
      stepJp: "外側ダイヤ",
      tab:1,
      name: "彫りのみ（星彫り）",
      property: "outsideDia",
      val: "hoshiboriBase",
      //option:null,
      summary:"",
      price:5000,
    },
    // {
    //   id:4111,
    //   step: 7,
    //   stepJp: "外側ダイヤ",
    //   tab:1,
    //   name: "外側ダイヤ不要",
    //   property: "outsideDia",
    //   val: "",
    //   option:null,
    //   summary:"",
    // },
    //tab 2
    {
      id:42,
      step: 7,
      stepJp: "外側ダイヤ",
      tab:2,
      name: "ローズカット（8点留め）",
      property: "outsideDia",
      val: "rosecuthachitendomeBase",
      summary:"",
      price:11000//10000,
    },
    // {
    //   id:43,
    //   step: 7,
    //   stepJp: "外側ダイヤ",
    //   tab:2,
    //   name: "ローズカット（ふせこみ）",
    //   property: "outsideDia",
    //   val: "roseFuse",
    //   summary:"",
    // },
    {
      id:44,
      step: 7,
      stepJp: "外側ダイヤ",
      tab:2,
      name: "ローズカット（4点留め）",
      property: "outsideDia",
      val: "rosecutyontendomeBase",
      summary:"",
      price:11000//10000,
    },
    // {
    //   id:45,
    //   step: 7,
    //   stepJp: "外側ダイヤ",
    //   tab:2,
    //   name: "星留め（横長）",
    //   property: "outsideDia",
    //   val: "hoshidomeBase",
    //   summary:"",
    //   price:10000,
    // },
    // {
    //   id:4112,
    //   step: 7,
    //   stepJp: "外側ダイヤ",
    //   tab:2,
    //   name: "外側ダイヤ不要",
    //   property: "outsideDia",
    //   val: "",
    //   option:null,
    //   summary:"",
    // },
    // tab 3
    {
      id:46,
      step: 7,
      stepJp: "外側ダイヤ",
      tab:3,
      name: "ひねり留め",
      property: "outsideDia",
      val: "hineridome",
      summary:"",
      price:40000,//50000,
    },
    {
      id:47,
      step: 7,
      stepJp: "外側ダイヤ",
      tab:3,
      name: "ひねり彫り",
      property: "outsideDia",
      val: "hineriboriBase",
      summary:"",
      price:5000,
    },
    {
      id:48,
      step: 7,
      stepJp: "外側ダイヤ",
      tab:3,
      name: "ふせこみランダム（3個）",
      property: "outsideDia",
      val: "fusekomirandom3Base",
      summary:"",
      price:21000,
    },
    // {
    //   id:49,
    //   step: 7,
    //   stepJp: "外側ダイヤ",
    //   tab:3,
    //   name: "ふせこみランダム（5個）",
    //   property: "outsideDia",
    //   val: "fusekomirandom5Base",
    //   summary:"",
    //   price:35000,
    //   imgExplain: "※画像はふせこみランダム（3個）",
    // },
    // {
    //   id:50,
    //   step: 7,
    //   stepJp: "外側ダイヤ",
    //   tab:3,
    //   name: "ふせこみランダム（8個）",
    //   property: "outsideDia",
    //   val: "fusekomirandom8Base",
    //   summary:"",
    //   price:48000,
    //   imgExplain: "※画像はふせこみランダム（3個）",
    // },
    // {
    //   id:51,
    //   step: 7,
    //   stepJp: "外側ダイヤ",
    //   tab:3,
    //   name: "爪留めランダム（3個）",
    //   property: "outsideDia",
    //   val: "tumedomerandom3Base",
    //   summary:"",
    //   price:21000,
    //   imgExplain: "※画像は爪留めランダム（5個）",
    // },
    {
      id:52,
      step: 7,
      stepJp: "外側ダイヤ",
      tab:3,
      name: "爪留めランダム（5個）",
      property: "outsideDia",
      val: "tumedomerandom5Base",
      summary:"",
      price:35000,
    },
    // {
    //   id:53,
    //   step: 7,
    //   stepJp: "外側ダイヤ",
    //   tab:3,
    //   name: "爪留めランダム（8個）",
    //   property: "outsideDia",
    //   val: "tumedomerandom8Base",
    //   summary:"",
    //   price:48000,
    //   imgExplain: "※画像は爪留めランダム（5個）",
    // },
    // {
    //   id:4113,
    //   step: 7,
    //   stepJp: "外側ダイヤ",
    //   tab:3,
    //   name: "外側ダイヤ不要",
    //   property: "outsideDia",
    //   val: "",
    //   option:null,
    //   summary:"",
    // },
  ]
}
